export class RetailFreeShippingConstants {
    public static RFS_PARTICIPATING = 20;
    public static RFS_NOT_PARTICIPATING = 21;
    public static EXPEDITED_EXPENSIVE_SHORT_CODE = "FEX2DY";
    public static FREE_SHIPPING_SHORT_CODE = "FEXGRD";
    public static ShortCode = ["FEX2DY"];
    public static FREE_SHIPPING ="Free Shipping"
}


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/retail-free-shipping.constants.ts